import { api } from "@/lib/api";

const SID_KEY = "ag_sid";
const AID_KEY = "ag_aid";
const UTM_KEY = "ag_utm";

const uid = () => (crypto?.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

function getId(key) {
  let v = localStorage.getItem(key);
  if (!v) {
    v = uid();
    localStorage.setItem(key, v);
  }
  return v;
}

// Session id resets after 30 min of inactivity.
function sessionId() {
  const now = Date.now();
  const last = Number(sessionStorage.getItem("ag_sid_ts") || 0);
  let sid = sessionStorage.getItem(SID_KEY);
  if (!sid || now - last > 30 * 60 * 1000) {
    sid = uid();
    sessionStorage.setItem(SID_KEY, sid);
  }
  sessionStorage.setItem("ag_sid_ts", String(now));
  return sid;
}

function deviceType() {
  const w = window.innerWidth;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

// Capture & persist UTM params from the first landing URL of the session.
export function captureUtm() {
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => {
    const v = p.get(k);
    if (v) utm[k] = v;
  });
  if (Object.keys(utm).length) localStorage.setItem(UTM_KEY, JSON.stringify(utm));
}

function storedUtm() {
  try {
    return JSON.parse(localStorage.getItem(UTM_KEY)) || {};
  } catch {
    return {};
  }
}

export function trackEvent(event, extra = {}) {
  try {
    const utm = storedUtm();
    api.post("/track", {
      event,
      session_id: sessionId(),
      anonymous_id: getId(AID_KEY),
      page: window.location.pathname,
      referrer: document.referrer || "",
      utm_source: utm.utm_source || null,
      utm_medium: utm.utm_medium || null,
      utm_campaign: utm.utm_campaign || null,
      device: deviceType(),
      screen: `${window.innerWidth}x${window.innerHeight}`,
      ...extra,
    }).catch(() => {});
  } catch {}
}

export const trackPageView = () => trackEvent("page_view");

// Stable per-checkout id, persisted for the browser tab session.
const CID_KEY = "ag_cid";
export function checkoutId() {
  let cid = sessionStorage.getItem(CID_KEY);
  if (!cid) {
    cid = uid();
    sessionStorage.setItem(CID_KEY, cid);
  }
  return cid;
}
